import { BASE_URL } from '@router/consts'

const p = (postfix: string) => `${BASE_URL}${postfix}`

export const LIST_URL = p('policies/list/')
export const DETAILS_URL = p('policies/:id/')
